import { Link } from "react-router-dom";
import { useCart } from "@/lib/cart";
import { fileUrl } from "@/lib/api";
import { Trash2, Minus, Plus } from "lucide-react";

export default function CartPage() {
    const { items, setQty, remove, subtotal, clear } = useCart();

    return (
        <div className="max-w-4xl mx-auto px-4 sm:px-6 py-12" data-testid="cart-page">
            <h1 className="font-serif-luxe text-3xl sm:text-5xl chrome-text font-semibold mb-10">Votre panier</h1>

            {items.length === 0 ? (
                <div data-testid="cart-page-empty" className="glass-card rounded-2xl p-12 text-center text-slate-400">
                    Panier vide.
                    <div className="mt-6">
                        <Link to="/boutique" data-testid="cart-continue-shopping" className="btn-primary">
                            Découvrir la collection
                        </Link>
                    </div>
                </div>
            ) : (
                <div className="grid grid-cols-1 md:grid-cols-12 gap-8">
                    <div className="md:col-span-7 space-y-4">
                        {items.map((it) => (
                            <div key={`${it.product_id}-${it.variant_id}-${it.finition || ""}`} data-testid={`cart-page-item-${it.variant_id}`} className="glass-card rounded-2xl p-4 flex gap-4">
                                <img src={fileUrl(it.image)} alt={it.name} className="w-24 h-24 object-cover rounded-xl bg-black/40" />
                                <div className="flex-1">
                                    <div className="flex items-start justify-between gap-3">
                                        <div>
                                            <Link to={`/produit/${it.slug}`} className="font-serif-luxe text-lg text-slate-100 hover:text-white">
                                                {it.name}
                                            </Link>
                                            <div className="text-xs text-slate-400 mt-1">{it.variant_label}</div>
                                        </div>
                                        <button
                                            data-testid={`cart-page-remove-${it.variant_id}`}
                                            onClick={() => remove(it.product_id, it.variant_id, it.finition || "")}
                                            className="text-slate-500 hover:text-red-400"
                                            aria-label="Retirer"
                                        ><Trash2 className="w-4 h-4" /></button>
                                    </div>
                                    <div className="flex items-center justify-between mt-3">
                                        <div className="flex items-center gap-2">
                                            <button data-testid={`cart-page-minus-${it.variant_id}`} onClick={() => setQty(it.product_id, it.variant_id, it.quantity - 1, it.finition || "")} className="p-1.5 border border-white/10 rounded-lg"><Minus className="w-3.5 h-3.5" /></button>
                                            <span data-testid={`cart-page-qty-${it.variant_id}`} className="text-sm w-8 text-center">{it.quantity}</span>
                                            <button data-testid={`cart-page-plus-${it.variant_id}`} onClick={() => setQty(it.product_id, it.variant_id, it.quantity + 1, it.finition || "")} className="p-1.5 border border-white/10 rounded-lg"><Plus className="w-3.5 h-3.5" /></button>
                                        </div>
                                        <div className="font-semibold text-slate-100">{(it.price_cad * it.quantity).toFixed(2)} $</div>
                                    </div>
                                </div>
                            </div>
                        ))}
                        <button data-testid="cart-clear-btn" onClick={clear} className="text-xs text-slate-500 hover:text-slate-300 uppercase tracking-widest">
                            Vider le panier
                        </button>
                    </div>
                    <div className="md:col-span-5">
                        <div className="glass-card rounded-2xl p-6 sticky top-24">
                            <div className="text-xs uppercase tracking-widest text-slate-500 mb-4">Résumé</div>
                            <div className="space-y-2 text-sm">
                                <div className="flex justify-between"><span className="text-slate-400">Sous-total</span><span data-testid="cart-page-subtotal">{subtotal.toFixed(2)} $</span></div>
                                <div className="flex justify-between"><span className="text-slate-400">Livraison</span><span>{subtotal >= 500 ? "Offerte" : "15,00 $"}</span></div>
                                <div className="flex justify-between text-xs text-slate-500"><span>TPS/TVQ</span><span>Calculées à l'étape suivante</span></div>
                            </div>
                            <div className="hair-divider my-4" />
                            <div className="flex justify-between font-semibold text-slate-100">
                                <span>Estimation</span>
                                <span data-testid="cart-page-total-estimate">{(subtotal + (subtotal >= 500 ? 0 : 15)).toFixed(2)} $</span>
                            </div>
                            <Link to="/commande" data-testid="cart-checkout-btn" className="btn-primary w-full mt-6">
                                Passer commande
                            </Link>
                            <div className="mt-4 text-[11px] text-slate-500 text-center">
                                Livraison Postes Canada · Gratuite dès 500 $
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
